import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AdminToolsDataService from "../../services/admin-tools.service";
import { useSelector, useDispatch } from "react-redux";
import { NotificationManager } from "react-notifications";
import catalogJewelryService from "../../services/catalog-jewelry.service";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Button, Modal, Select, Spin, Table, Tooltip } from "antd";
import PhoneInputComponent from "../User Profile/PhoneInputComponent";

// Helper function to extract first valid phone number from string
const extractPhoneNumber = (phoneString) => {
  if (!phoneString || typeof phoneString !== "string") return "";
  
  // Pattern to match phone numbers like: (605) 362-0008, +14806560652, 605-362-0008, etc.
  const phoneRegex = /\+?1?\s*\(?[0-9]{3}\)?\s*[-.]?\s*[0-9]{3}[-.]?\s*[0-9]{4}(\s*x\d+)?/;
  const match = phoneString.match(phoneRegex);
  
  if (match) {
    return match[0].trim();
  }
  
  return phoneString.trim();
};

export const InviteYourRetailer = (props) => {
  const { t } = useTranslation();
  const { Option } = Select;
  const loginDetials = useSelector((state) => state.loginReducer);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [dealerId, setDealerId] = useState(0);
  const [dealerCompany, setDealerCompany] = useState("");
  const initialstate = {
    dealerID: "",
    companyName: "",
    city: "",
    state: "",
    country: "",
    contactName: "",
    email: "",
    phoneNumber: "",
  };

  const [switchValue, setswitchValue] = useState(true);
  const [venderdata, setVenderData] = useState(initialstate);
  const [validations, setValidations] = useState({
    companyNameVal: "",
    cityVal: "",
    stateVal: "",
    countryVal: "",
    contactNameVal: "",
    emailVal: "",
    phoneNumberVal: "",
  });
  const [type, SetType] =  useState("");

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          setDealerCompany(
            loginDetials.loginDetials.responseData.dealerCompany
          );
        }
      }
    }

    const data = JSON.parse(localStorage.getItem("retailerRow"));

    if (data) {
      SetType("InviteNewRetailer");
      // 1. Set all values from localStorage into venderdata
      const toPureInt = v => /^\d+$/.test(v?.toString()?.trim()) ? parseInt(v) : null;
      const stateId = toPureInt(data.dealerStateID) ?? toPureInt(data.dealerState);
      const cityId = toPureInt(data.dealerCityID) ?? toPureInt(data.dealerCity);

      setVenderData((prev) => ({
        ...prev,
        dealerID: data.dealerID || "",
        companyName: data.dealerCompany || "",
        contactName: data.dealerName || "",
        email: data.dealerEmail || "",
        phoneNumber: data.dealerPhone || "",
        // ,
        country: data.dealerCountryID || "",
        state: stateId || "",
        city: cityId || ""
      }));

      // 2. Preload dependent dropdowns if country/state exist

      handleGetLocationDropdownDetailsByCountry(
        parseInt(data?.dealerCountryID) ?? null,
        stateId,
        cityId
      );
      // if (data?.country) {
      //   handleGetLocationDropdownDetailsByState(parseInt(data.dealerCountryID), parseInt(data.dealerStateID), "State");
      // }
      // if (data?.state) {
      //   handleGetLocationDropdownDetailsByCity(parseInt(data.dealerStateID), parseInt(data.dealerCity), "City");
      // }

      // ✅ Remove from localStorage after using
      localStorage.removeItem("retailerRow");
    } else {
      handleGetLocationDropdownDetailsByCountry();
      //handleGetLocationDropdownDetailsByState(233, null, "State", null);
    }
  }, []);

  const handleCountryStateValue = () => {
    handleGetLocationDropdownDetailsByCountry();
    handleGetLocationDropdownDetailsByState(233, null, "State", null);
  };

  const handleSwitch = () => {
    setswitchValue(!switchValue);
  };

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select") {
      setVenderData({
        ...venderdata,
        [name]: e,
      });
      if (name === "country") {
        setValidations((prevdata) => ({
          ...prevdata,
          countryVal: "",
        }));
        setVenderData((prevdata) => ({
          ...prevdata,
          state: "",
        }));

        handleGetLocationDropdownDetailsByState(e, null, "State");
      }
      if (name === "state") {
        setValidations((prevdata) => ({
          ...prevdata,
          stateVal: "",
        }));
        setVenderData((prevdata) => ({
          ...prevdata,
          city: "",
        }));
        handleGetLocationDropdownDetailsByCity(e, "City");
      }
      if (name === "city") {
        setValidations((prevdata) => ({
          ...prevdata,
          cityVal: "",
        }));
      }
    } else {
      setVenderData({
        ...venderdata,
        [e.target.name]: e.target.value,
      });
      if (e.target.name === "companyName") {
        setValidations((prevdata) => ({
          ...prevdata,
          companyNameVal: "",
        }));
      }
      if (e.target.name === "city") {
        setValidations((prevdata) => ({
          ...prevdata,
          cityVal: "",
        }));
      }
      if (e.target.name === "state") {
        setValidations((prevdata) => ({
          ...prevdata,
          stateVal: "",
        }));
      }
      if (e.target.name === "country") {
        setValidations((prevdata) => ({
          ...prevdata,
          countryVal: "",
        }));
      }
      if (e.target.name === "contactName") {
        setValidations((prevdata) => ({
          ...prevdata,
          contactNameVal: "",
        }));
      }
      if (e.target.name === "email") {
        setValidations((prevdata) => ({
          ...prevdata,
          emailVal: "",
        }));
      }
      if (e.target.name === "phoneNumber") {
        setValidations((prevdata) => ({
          ...prevdata,
          phoneNumberVal: "",
        }));
      }
    }
  };

  // Validation

  const handleValidation = () => {
    const {
      companyName,
      city,
      state,
      country,
      contactName,
      email,
      phoneNumber,
    } = venderdata;

    const validations = {
      companyNameVal: "",
      cityVal: "",
      stateVal: "",
      countryVal: "",
      contactNameVal: "",
      emailVal: "",
      phoneNumberVal: "",
    };
    let isValid = true;

    if (!companyName.trim()) {
      isValid = false;
      validations.companyNameVal = t("Company name is compulsory");
    } else {
      validations.companyNameVal = "";
    }

    // if (!city.trim()) {
    //   isValid = false;
    //   validations.cityVal = t("City is compulsory");
    // } else if (!/^[A-Za-z . ,'-]+$/.test(city)) {
    //   isValid = false;
    //   validations.cityVal = t("City is invalid");
    // } else {
    //   validations.cityVal = "";
    // }

    // if (!state.trim()) {
    //   isValid = false;
    //   validations.stateVal = t("State is compulsory");
    // } else if (!/^[A-Za-z . ,'-]+$/.test(state)) {
    //   isValid = false;
    //   validations.stateVal = t("State is invalid");
    // } else {
    //   validations.stateVal = "";
    // }

    if (locationDropdownListByState.length > 0) {
      if (!state) {
        isValid = false;
        validations.stateVal = t("State is compulsory");
      } else {
        validations.stateVal = "";
      }
    }

    if (locationDropdownListByCity.length > 0) {
      if (!city) {
        isValid = false;
        validations.cityVal = t("City is compulsory");
      } else {
        validations.cityVal = "";
      }
    }
    // if (!country) {
    //   isValid = false;
    //   validations.countryVal = t("Country is compulsory");
    // } else if (!/^[A-Za-z . ,'-]+$/.test(country)) {
    //   isValid = false;
    //   validations.countryVal = t("Country is invalid");
    // } else {
    //   validations.countryVal = "";
    // }

    if (!country) {
      isValid = false;
      validations.countryVal = t("Kindly select the Country");
    } else {
      validations.countryVal = "";
    }
    if (!contactName.trim()) {
      isValid = false;
      validations.contactNameVal = t("Contact name is compulsory");
    } else if (!/^[A-Za-z . ,'-]+$/.test(contactName)) {
      isValid = false;
      validations.contactNameVal = t("Contact name is invalid");
    } else {
      validations.contactNameVal = "";
    }
    // var validRegex =
    //   /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    // if (!email.trim()) {
    //   isValid = false;
    //   validations.emailVal = t("Email address is compulsory");
    // } else if (!email.match(validRegex)) {
    //   isValid = false;
    //   validations.emailVal = t("Email address is invalid");
    // } else {
    //   validations.emailVal = "";
    // }
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*/=?^_`{|}~]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var validEmailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!email.trim()) {
      isValid = false;
      validations.emailVal = t("Email address is compulsory");
    } else if (!email.match(validEmailRegex)) {
      isValid = false;
      validations.emailVal = t("Email address is invalid");
    } else {
      if (!email.match(validRegex)) {
        isValid = false;
        validations.emailVal = t("Email address is invalid");
      } else {
        validations.emailVal = "";
      }
    }
    // if (!phoneNumber.trim()) {
    //   isValid = false;
    //   validations.phoneNumberVal = t("Phone number is compulsory");
    // } else if (!/^(?!0{10,15})(\+\d{1,3}[- ]?)?\d{10,15}$/.test(phoneNumber)) {
    //   isValid = false;
    //   validations.phoneNumberVal = t("Phone number is invalid");
    // } else {
    //   validations.phoneNumberVal = "";
    // }

    if (!phoneNumber.trim()) {
      isValid = false;
      validations.phoneNumberVal = t("Phone number is compulsory");
    } else if (
      (phoneNumber.length >= 10 && phoneNumber.includes("-")) ||
      (phoneNumber.length >= 10 && phoneNumber.includes(",")) ||
      (phoneNumber.length >= 10 && phoneNumber.includes("+"))
    ) {
      validations.phoneNumberVal = "";
    } else if (!/^[ ()+]*([0-9][ ()+]*){10,15}$/.test(phoneNumber)) {
      isValid = false;
      validations.phoneNumberVal = t("Phone number is invalid");
    } else {
      validations.phoneNumberVal = "";
    }

    setValidations(validations);
    return isValid;
  };

  // Submit
  const handleSubmit = () => {
    // ;
    var isValid = handleValidation();
    if (!isValid) {
      return false;
    }
    setVenderData({
      dealerID: "",
      companyName: "",
      city: "",
      state: "",
      country: "",
      contactName: "",
      email: "",
      phoneNumber: "",
    });
  };

  const { companyName, city, state, country, contactName, email, phoneNumber } =
    venderdata;
  const {
    companyNameVal,
    cityVal,
    stateVal,
    countryVal,
    contactNameVal,
    emailVal,
    phoneNumberVal,
  } = validations;

  const [countryListLoading, setCountryListLoading] = useState(false);
  const [locationDropdownListByCountry, setLocationDropdownListByCountry] =
    useState([]);
  const [locationDropdownListByState, setLocationDropdownListByState] =
    useState([]);
  const [locationDropdownListByCity, setLocationDropdownListByCity] = useState(
    []
  );

  const handleGetLocationDropdownDetailsByCountry = (
    selectedCountryId = null,
    selectedState = null,
    selectedCity = null
  ) => {
    try {
      let inputData = {
        id: 0,
        dropdownType: "Country",
      };
      setCountryListLoading(true);
      AdminToolsDataService.GetLocationDropdownDetails(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setLocationDropdownListByCountry(responseData);
              setVenderData((prevState) => ({
                ...prevState,
                country: selectedCountryId ?? prevState.country ?? 233,
              }));
              if (selectedState != null || selectedCountryId != null) {
                handleGetLocationDropdownDetailsByState(
                  parseInt(selectedCountryId),
                  selectedState,
                  "State",
                  selectedCity
                );
              } else {
              /* handleGetLocationDropdownDetailsByState(
                  233,
                  null,
                  "State",
                  null
                );*/
              }

              setCountryListLoading(false);
            } else {
              setLocationDropdownListByCountry([]);
              setCountryListLoading(false);
            }
          } else {
            setLocationDropdownListByCountry([]);
            setCountryListLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setCountryListLoading(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetLocationDropdownDetailsByState = (
    id,
    selectedState = null,
    dropdownType,
    selectedCity = null
  ) => {
    try {
      let inputData = {
        id: id,
        dropdownType: dropdownType,
      };
      AdminToolsDataService.GetLocationDropdownDetails(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setLocationDropdownListByState(responseData);

            const stateObj = responseData.find(
              (item) => item?.id === selectedState
            );

            const stateId = stateObj ? stateObj.id : null; 

            if (stateId != null) {
              setVenderData((prevState) => ({
                ...prevState,
                state: stateId,
              }));

              if (selectedCity != null || stateId != null) {
                handleGetLocationDropdownDetailsByCity(
                  stateId,
                  "City",
                  selectedCity
                );
              }
            } else {
              // here
              //handleGetLocationDropdownDetailsByCity(stateId, "City", null);
            }
          } else {
            setLocationDropdownListByState([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetLocationDropdownDetailsByCity = (
    id,
    dropdownType,
    selectedCity
  ) => {
    try {
      let inputData = {
        id: id,
        dropdownType: dropdownType,
      };
      AdminToolsDataService.GetLocationDropdownDetails(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setLocationDropdownListByCity(responseData);

            const cityObj = responseData.find(
              (item) => item?.id === selectedCity
            );

            const cityId = cityObj ? cityObj.id : null;
            console.log("City ID:", cityId);

            if (cityId != null) {
              setVenderData((prevState) => ({
                ...prevState,
                city: cityId,
              }));
            }
          } else {
            setLocationDropdownListByCity([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // For Company Name
  const [isCompanyName, setIsCompanyName] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isEmail, setIsEmail] = useState(true);
  const [isUserName, setIsUserName] = useState(true);

  const handleCheckDealerCompanyName = async () => {
    try {
      if (!venderdata.companyName) {
        return false;
      }
      let inputData = {
        companyName: venderdata.companyName,
      };
      setLoading(true);
      await AdminToolsDataService.CheckDealerCompanyName(inputData)
        .then((response) => {
          // var message = response.data.message;
          var checkMessage = response.data.responseData.isCompanyExist;
          setLoading(false);
          setValidations((prevState) => ({
            ...prevState,
            companyNameVal: checkMessage ? t("Company name is Taken") : "",
          }));
          setIsCompanyName(checkMessage);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleCheckDealerEmail = async () => {
    try {
      if (!venderdata.email) {
        return false;
      }
      let inputData = {
        email: venderdata.email,
      };

      var isValid = true;
      await AdminToolsDataService.CheckDealerEmail(inputData)
        .then((response) => {
          // var message = response.data.message;
          var checkMessage = response.data.responseData.isEmailExist;
          setLoading(false);
          setValidations((prevState) => ({
            ...prevState,
            emailVal: checkMessage ? "Email is Taken" : "",
          }));
          setIsEmail(checkMessage);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleCheckDealerUser = () => {
    try {
      if (!venderdata.contactName) {
        return false;
      }
      let inputData = {
        userName: venderdata.contactName,
      };

      var isValid = true;
      AdminToolsDataService.CheckDealerUser(inputData)
        .then((response) => {
          // var message = response.data.message;
          var checkMessage = response.data.responseData.isUserNameExist;
          setLoading(false);
          isValid = checkMessage;
          setValidations((prevState) => ({
            ...prevState,
            contactNameVal: checkMessage && t("Username is Taken"),
          }));
          setIsUserName(checkMessage);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  // Invite vendor

  const handleInviteVendor = async () => {
    var isValid = handleValidation();
    // setIsEmail(true);
    // setIsCompanyName(true);
    // setIsUserName(true);
    if (!isValid) {
      return false;
    } else {
      // await handleCheckDealerCompanyName();
      // await handleCheckDealerEmail();
      // await handleCheckDealerUser();
      // if (!isCompanyName && !isEmail && !isUserName) {
      
      //console.log('GF:venderdata.dealerID: ' + venderdata.dealerID);
      //console.log('GF:venderdata.dealerID_New: ' + parseInt(venderdata?.dealerID || 0));
      try {
        let inputData = {
          dealerId: dealerId,
          requestedDealerId: parseInt(venderdata?.dealerID || 0),
          companyName: venderdata.companyName.toString(),
          companyName: venderdata.companyName.toString(),
          cityId: Number(venderdata.city),
          stateId: Number(venderdata.state),
          countryId: Number(venderdata.country),
          contactName: venderdata.contactName.toString(),
          emailAddress: venderdata.email.toString(),
          phoneNumber: venderdata.phoneNumber.toString(),
          type: "Retailer",
        };
        setSubmitLoading(true);
        AdminToolsDataService.CreateInviteRetailer(inputData)
          .then((response) => {
            var message = response.data.message;
            var responseData = response.data.responseData;
            var returnMessage = responseData.returnMessage;
            if (message === "Success") {
              if (returnMessage == "Invite Added SUCESSFULLY") {
                setSubmitLoading(false);
                setVenderData({
                  companyName: "",
                  city: "",
                  state: "",
                  country: "",
                  contactName: "",
                  email: "",
                  phoneNumber: "",
                });
                handleCountryStateValue();
                setIsModalSendInvitationVisible(false);
                NotificationManager.success(t("Invitation Sent Successfully"));
              } else {
                setVenderData({
                  companyName: "",
                  city: "",
                  state: "",
                  country: "",
                  contactName: "",
                  email: "",
                  phoneNumber: "",
                });
                handleCountryStateValue();
                setSubmitLoading(false);
                setIsModalSendInvitationVisible(false);
                NotificationManager.error(t("Invite Not Sent."));
              }
            } else {
              setVenderData({
                companyName: "",
                city: "",
                state: "",
                country: "",
                contactName: "",
                email: "",
                phoneNumber: "",
              });
              handleCountryStateValue();
              setSubmitLoading(false);
              setIsModalSendInvitationVisible(false);
              NotificationManager.error(t("Invite Not Added."));
            }
          })
          .catch((error) => {
            console.log(error);
            setSubmitLoading(false);
            setIsModalSendInvitationVisible(false);
          });
      } catch (error) {
        console.log(error);
        setSubmitLoading(false);
        setIsModalSendInvitationVisible(false);
      }
      // }
    }
  };

  // Modal Email
  const [emailLoading, setEmailLoading] = useState(false);
  const [content, setContent] = useState("");
  const [isModalSendInvitationVisible, setIsModalSendInvitationVisible] =
    useState(false);
  const handleSendInvitationModalCancel = () => {
    setIsModalSendInvitationVisible(false);
  };

  const handleSendEmail = () => {
    handleInviteVendor();
    // handleGetEmailData();
  };

  const handleGetEmailContent = () => {
    var isValid = handleValidation();
    if (!isValid) {
      return false;
    }
    setIsModalSendInvitationVisible(true);
    handleGetEmailData();
  };
  const handleGetEmailData = () => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        type: type ? type : "NewRetailer",
        fromDealerComapny: venderdata.companyName.toString(),
        toDealerCompany: dealerCompany.toString(),
        cityId: Number(venderdata.city),
        stateId: Number(venderdata.state),
        countryId: Number(venderdata.country),
        emailAddress: venderdata.email,
        phoneNumber: venderdata.phoneNumber
      };
      setEmailLoading(true);
      catalogJewelryService
        .GetInviteNewRetailerEmail(inputData)
        .then((response) => {
          setEmailLoading(false);
          var message = response.data.message;
          var responseData = response.data.responseData.emailcontent;
          const emailContent = responseData;
          if (message === "Success") {
            const countryName = locationDropdownListByCountry.find(c => c.id === country)?.name || "";
            const stateName = locationDropdownListByState.find(s => s.id === state)?.name || "";
            const cityName = locationDropdownListByCity.find(c => c.id === city)?.name || "";
            const currentuserAddress= cityName + ", " + stateName + ", " + countryName;
            const updatedEmail= emailContent.replaceAll("@@RetailerName", venderdata?.companyName || "")
            .replaceAll("@@VendorName",loginDetials?.loginDetials?.responseData?.dealerCompany || "")
            .replaceAll("@@ContactName", loginDetials?.loginDetials?.responseData?.dealerName || "")
            .replaceAll("@@Email",loginDetials?.loginDetials?.responseData?.userEmail || "")
            .replaceAll("@@Address", loginDetials?.loginDetials?.responseData?.dealerAddress || "")
            .replaceAll("@@Website", loginDetials?.loginDetials?.responseData?.websiteAddress || "")
            .replaceAll("@@RetailerContactName",venderdata?.contactName || "")
            .replaceAll("@@RetailerEmail",venderdata?.email || "")
            .replaceAll("@@RetailerAddress", currentuserAddress)
            setContent(updatedEmail);
          } else {
            setContent([]);
          }
        })
        .catch((error) => {
          console.log(error);
          setEmailLoading(false);
        });
    } catch (error) {
      console.log(error);
      setEmailLoading(false);
    }
  };

  return (
    <div className="form__fields">
      <div className="row">
        <div className="col-md-12">
          <div className="heading__block">
            <h4 class="workarea__heading mt-0 mb-0">
              {" "}
              {t("Invite Your Retailers")}{" "}
            </h4>
          </div>
        </div>
        <div className="col-lg-12 mt-4">
          <div className="row">
            <div className="col-lg-4">
              <div className="input__block">
                <label>
                  {t("Company Name")}
                  <span>*</span>
                </label>
                <input
                  type="textbox"
                  name="companyName"
                  value={companyName}
                  placeholder={t("Enter Company Name")}
                  onChange={handleOnChange}
                  className={companyNameVal && "border__red"}
                  //onBlur={handleCheckDealerCompanyName}
                  autoComplete="off"
                />
                <div>
                  {companyNameVal && (
                    <p className="error-color-red">{companyNameVal}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="input__block">
                <label>
                  {t("Country")}
                  <span>*</span>
                </label>
                {/* <input
                  type="textbox"
                  name="country"
                  value={country}
                  placeholder="Enter Country"
                  onChange={handleOnChange}
                  className={countryVal && "border__red"}
                /> */}
                <Select
                  className="border__grey"
                  placeholder={t("Select Country")}
                  value={country}
                  name="country"
                  showSearch
                  optionFilterProp="children"
                  onChange={(e) => handleOnChange(e, "select", "country")}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option>Select Country</Option>
                  {locationDropdownListByCountry.map((item) => {
                    return (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
                <div>
                  {countryVal && (
                    <p className="error-color-red">{countryVal}</p>
                  )}
                </div>
              </div>
            </div>
            {country && (
              <div className="col-lg-4">
                <div className="input__block">
                  <label>
                    {t("State")}
                    <span>*</span>
                  </label>
                  {/* <input
                  type="textbox"
                  name="state"
                  value={state}
                  placeholder="Enter State"
                  onChange={handleOnChange}
                  className={stateVal && "border__red"}
                /> */}
                  <Select
                    showSearch
                    name="state"
                    placeholder={t("Select State")}
                    value={state ? state : null}
                    autocomplete="off"
                    optionFilterProp="children"
                    // onChange={onChange}
                    onChange={(e) => handleOnChange(e, "select", "state")}
                    //   onSearch={onSearch}
                    className={stateVal ? "border__red" : "border__grey"}
                  >
                    {locationDropdownListByState.map((item) => {
                      return (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      );
                    })}
                  </Select>
                  <div>
                    {stateVal && <p className="error-color-red">{stateVal}</p>}
                  </div>
                </div>
              </div>
            )}

            {state && (
              <div className="col-lg-4">
                <div className="input__block">
                  <label>
                    {t("City")}
                    <span>*</span>
                  </label>
                  {/* <input
                        type="textbox"
                        name="city" 
                        value={city}
                        placeholder="Enter City"
                        onChange={handleOnChange}
                        className={cityVal && "border__red"}
                    /> */}
                  <Select
                    showSearch
                    name="city"
                    placeholder={t("Select City")}
                    value={city ? city : null}
                    autocomplete="off"
                    optionFilterProp="children"
                    // onChange={onChange}
                    onChange={(e) => handleOnChange(e, "select", "city")}
                    //   onSearch={onSearch}
                    className={cityVal ? "border__red" : "border__grey"}
                  >
                    {locationDropdownListByCity.map((item) => {
                      return (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      );
                    })}
                  </Select>
                  <div>
                    {cityVal && <p className="error-color-red">{cityVal}</p>}
                  </div>
                </div>
              </div>
            )}

            <div className="col-lg-4">
              <div className="input__block">
                <label>
                  {t("Contact Name")}
                  <span>*</span>
                </label>
                <input
                  type="textbox"
                  name="contactName"
                  value={contactName}
                  placeholder={t("Enter Contact Name")}
                  onChange={handleOnChange}
                  className={contactNameVal && "border__red"}
                  //onBlur={handleCheckDealerUser}
                  autoComplete="off"
                />
                <div>
                  {contactNameVal && (
                    <p className="error-color-red">{contactNameVal}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="input__block">
                <label>
                  {t("E-Mail Address")}
                  <span>*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  placeholder={t("Enter E-Mail Address")}
                  onChange={handleOnChange}
                  className={emailVal && "border__red"}
                  //onBlur={handleCheckDealerEmail}
                  autoComplete="off"
                />
                <div>
                  {emailVal && <p className="error-color-red">{emailVal}</p>}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <PhoneInputComponent
                t={t}
                phone={typeof phoneNumber !== "object" ? phoneNumber : ""}
                setPhone={(val) =>
                  handleOnChange({
                    target: { name: "phoneNumber", value: val },
                  })
                }
                phoneError={validations.LocationPhoneVal}
                setPhoneError={(err) =>
                  setValidations((prev) => ({ ...prev, LocationPhoneVal: err }))
                }
              />
            </div>

            {/* <div className="col-lg-4">
              <div className="input__block">
                <label>
                  {t("Phone Number")}
                  <span>*</span>
                </label>
                <input
                  type="number"
                  name="phoneNumber"
                  value={phoneNumber}
                  placeholder={t("Enter Phone Number")}
                  onChange={handleOnChange}
                  className={phoneNumberVal && "border__red"}
                  autoComplete="off"
                />
                <div>
                  {phoneNumberVal && (
                    <p className="error-color-red">{phoneNumberVal}</p>
                  )}
                </div>
              </div>
            </div> */}
            <div className="col-lg-12">
              <Button
                // loading={submitLoading}
                onClick={handleGetEmailContent}
                className="primary-btn"
              >
                {" "}
                {t("Send Invitation")}{" "}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Vendor Email Content */}
      <Modal
        title="Send Email"
        visible={isModalSendInvitationVisible}
        className="forgot__password"
        onCancel={handleSendInvitationModalCancel}
        footer={[
          <div className="d-block">
            <Button
              loading={submitLoading}
              className="primary-btn"
              key="submit"
              onClick={handleSendEmail}
            >
              {t("Send")}
            </Button>
          </div>,
        ]}
      >
        <div className="form__fields p-0 border-0 mh-auto">
          <div className="editor__section">
            <Spin spinning={emailLoading}>
              <CKEditor
                editor={ClassicEditor}
                data={content ? content : ""}
                // config={editorConfiguration}
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setContent(data);
                }}
              />
            </Spin>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default InviteYourRetailer;
